export default {
  name: "PasswordResetComplete",
  data() {
    return ({
      success_message: "Your password has been reset successfully!",
    });
  }
};
